import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { UserData } from '@/Support/Users/Interfaces/UserData'
import { TeamData } from '@/Support/Teams/Interfaces/TeamData'
import { TeamPreferencesInterface } from '@/Support/Teams/Interfaces/TeamPreferencesInterface'

export const userData = computed<UserData>(
  () => usePage().props?.user as unknown as UserData,
)

export const teamData = computed<TeamData>(
  () => userData.value.currentTeam as TeamData,
)

export const teamPreferences = computed<TeamPreferencesInterface>(
  () => userData.value.teamPreferences,
)

export const userDataLocale = computed(
  () => userData.value.userPreferences.locale,
)

export const userDataLanguage = computed(
  () => userData.value.userPreferences.language,
)
